var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C9.982 5 5 9.982 5 16c0 6.007 4.993 11 11 11zm0-7.323c-3.235 0-5.737 1.154-6.826 2.448A9.11 9.11 0 0 1 6.844 16c0-5.09 4.055-9.167 9.145-9.167S25.156 10.91 25.167 16a9.105 9.105 0 0 1-2.33 6.136c-1.089-1.294-3.59-2.459-6.837-2.459z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.03,
    cy: 13.66,
    opacity: 0.6,
    r: 3.768
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLightCircle);
export default __webpack_public_path__ + "static/media/User-Light_Circle.818c45e54b19decd3cac5b454ab1ff0e.svg";
export { ForwardRef as ReactComponent };